<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 197.21"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="74.476"
            cy="63.239"
            r="9.965"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M13.253 49.882c23.583,-14.102 48.69,-16.429 74.197,-6.643 -0.325,0.691 -0.672,1.366 -1.037,2.026 -0.464,0.841 -0.958,1.658 -1.535,2.421 -1.182,1.564 -2.716,2.903 -5.077,3.759 -3.514,1.276 -8.859,1.484 -13.406,1.599 -4.547,0.115 -8.294,0.136 -13.133,-0.079 -4.839,-0.215 -10.77,-0.666 -17.317,-0.41 -6.548,0.255 -13.713,1.217 -17.625,1.03 -3.683,-0.177 -4.483,-1.373 -5.129,-3.122 0.021,-0.193 0.041,-0.387 0.062,-0.581z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M82.345 7.022c-19.049,10.976 -39.62,10.739 -60.719,-0.79 0.003,-0.002 0.006,-0.004 0.009,-0.006 2.236,-1.288 4.749,-1.95 7.421,-2.263 2.673,-0.313 5.505,-0.278 7.24,0.081 1.735,0.358 2.374,1.04 3.843,1.541 1.47,0.501 3.769,0.822 6.969,1.054 3.201,0.232 7.301,0.375 9.84,0.127 2.54,-0.247 3.519,-0.886 5.047,-1.407 1.528,-0.522 3.606,-0.927 5.607,-1.076 2.002,-0.148 3.928,-0.042 6.062,0.054 2.134,0.096 4.477,0.181 6.627,1.288 0.707,0.364 1.393,0.838 2.054,1.397z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M39.028 13.218c-4.088,8.511 -4.217,18.134 -0.412,26.178 -8.61,2.033 -17.08,5.533 -25.363,10.486 -0.001,0.004 -0.001,0.007 -0.001,0.011 -0.073,0.043 -0.145,0.086 -0.217,0.13 -0.663,-1.915 -1.34,-4.389 -1.785,-6.879 -0.453,-2.538 -0.665,-5.093 -0.623,-8.798 0.043,-3.705 0.341,-8.56 1.192,-12.585 0.852,-4.024 2.258,-7.218 3.94,-9.774 1.68,-2.551 3.635,-4.466 5.867,-5.755 5.848,3.195 11.656,5.523 17.402,6.986z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M63.889 37.621c0.329,-6.795 -0.44,-14.84 -2.215,-23.175 7.051,-1.079 13.955,-3.554 20.671,-7.424 1.35,1.142 2.594,2.637 3.695,4.266 1.639,2.428 2.96,5.153 3.618,7.784 0.658,2.631 0.654,5.168 0.623,8.162 -0.032,2.995 -0.091,6.448 -0.696,9.566 -0.449,2.315 -1.199,4.446 -2.135,6.439 -0.721,-0.277 -1.443,-0.545 -2.164,-0.802 -7.175,-2.562 -14.316,-4.165 -21.397,-4.816z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M61.674 14.446c1.782,8.353 2.552,16.417 2.221,23.225 -8.517,-0.775 -16.954,-0.173 -25.258,1.786 -3.826,-8.063 -3.695,-17.718 0.419,-26.249 7.661,1.94 15.222,2.355 22.618,1.238z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M13.255 49.867c-3.138,29.177 2.258,61.55 16.188,97.118 6.006,12.187 13.345,13.679 14.245,4.407 1.691,-17.432 -1.45,-33.949 0.703,-55.445 1.513,-15.109 7.618,-18.07 12.775,-8.369 5.383,10.125 6.162,26.632 9.135,48.613 2.18,16.117 14.46,15.347 16.403,2.764 3.052,-19.768 3.239,-52.921 2.171,-91.271m4.783 -28.612c-0.658,-2.631 -1.979,-5.356 -3.618,-7.784 -1.64,-2.427 -3.598,-4.556 -5.749,-5.663 -2.15,-1.107 -4.493,-1.192 -6.627,-1.288 -2.134,-0.096 -4.06,-0.202 -6.062,-0.054 -2.001,0.149 -4.079,0.554 -5.607,1.076 -1.528,0.521 -2.507,1.16 -5.047,1.407 -2.539,0.248 -6.639,0.105 -9.84,-0.127 -3.2,-0.232 -5.499,-0.553 -6.969,-1.054 -1.469,-0.501 -2.108,-1.183 -3.843,-1.541 -1.735,-0.359 -4.567,-0.394 -7.24,-0.081 -2.672,0.313 -5.185,0.975 -7.421,2.263 -2.235,1.29 -4.194,3.206 -5.876,5.761 -1.682,2.556 -3.088,5.75 -3.94,9.774 -0.851,4.025 -1.149,8.88 -1.192,12.585 -0.042,3.705 0.17,6.26 0.623,8.798 0.453,2.537 1.147,5.058 1.823,6.987 0.676,1.929 1.335,3.266 5.247,3.454 3.912,0.187 11.077,-0.775 17.625,-1.03 6.547,-0.256 12.478,0.195 17.317,0.41 4.839,0.215 8.586,0.194 13.133,0.079 4.547,-0.115 9.892,-0.323 13.406,-1.599 3.513,-1.275 5.196,-3.617 6.612,-6.18 1.416,-2.563 2.567,-5.347 3.172,-8.465 0.605,-3.118 0.664,-6.571 0.696,-9.566 0.031,-2.994 0.035,-5.531 -0.623,-8.162z"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="79.881"
            cy="152.238"
            r="9.965"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
